import { render, staticRenderFns } from "./BlogOverlay.vue?vue&type=template&id=b2c10694&scoped=true&"
import script from "./BlogOverlay.vue?vue&type=script&lang=js&"
export * from "./BlogOverlay.vue?vue&type=script&lang=js&"
import style0 from "./BlogOverlay.vue?vue&type=style&index=0&id=b2c10694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c10694",
  null
  
)

export default component.exports